var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHours = function SvgHours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M23.034 12.498a.584.584 0 1 1-.002 1.169.585.585 0 1 1 .002-1.17M22.501 16.351a.583.583 0 1 1-.45 1.08.586.586 0 0 1-.316-.766.586.586 0 0 1 .766-.314M20.534 19.706a.584.584 0 1 1-.828.824.584.584 0 0 1 .828-.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M13.084 13.67a.585.585 0 0 1-.585-.587V4.89a.586.586 0 0 1 1.17 0v8.194a.585.585 0 0 1-.585.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M13.084 12.498a.587.587 0 0 0 0 1.171.587.587 0 0 0 0-1.171m0 2.34a1.756 1.756 0 0 1-1.756-1.755 1.756 1.756 0 0 1 3.512 0c0 .97-.788 1.756-1.756 1.756"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M13.084 25.96c-7.1 0-12.876-5.776-12.876-12.877C.208 5.983 5.984.208 13.084.208c6.108 0 11.416 4.338 12.622 10.317a.585.585 0 1 1-1.147.23C23.462 5.321 18.637 1.38 13.084 1.38c-6.455 0-11.706 5.25-11.706 11.704S6.63 24.79 13.084 24.79q.231 0 .462-.01c.304-.053.596.231.612.556a.586.586 0 0 1-.555.613q-.258.011-.52.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99D6D2",
    d: "M24.204 14.272a7.61 7.61 0 0 0-7.608 7.608 7.56 7.56 0 0 0 1.678 4.758 7.56 7.56 0 0 0 4.76 1.679 7.61 7.61 0 0 0 7.608-7.608c0-1.802-.63-3.456-1.678-4.758a7.56 7.56 0 0 0-4.76-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M23.034 28.903c-4.518 0-8.194-3.675-8.194-8.194 0-4.518 3.676-8.194 8.194-8.194 1.582 0 3.117.453 4.438 1.306a.586.586 0 0 1-.635.984 6.97 6.97 0 0 0-3.803-1.119 7.03 7.03 0 0 0-7.024 7.023c0 3.872 3.15 7.024 7.024 7.024s7.023-3.152 7.023-7.024c0-.75-.118-1.49-.35-2.196a.59.59 0 0 1 .373-.742.586.586 0 0 1 .738.376c.272.825.41 1.687.41 2.562 0 4.52-3.677 8.194-8.194 8.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B88",
    d: "M22.448 23.87h-.013a.6.6 0 0 1-.437-.212l-2.927-3.512a.586.586 0 0 1 .901-.75l2.497 2.998 7.275-8.036a.585.585 0 1 1 .862.79L22.88 23.68a.6.6 0 0 1-.433.19"
  }))));
};
export default SvgHours;